﻿import sanitize from './tk.sanitize';

export const getCurrentURI = () => `${window.location.pathname}${window.location.search}`;

export const removeSessionStorage = (key: string) => {
    window.sessionStorage.removeItem(key);
    return true;
};

export const removePersistentView = (url: string) => removeSessionStorage(url);

export const setSessionStorage = (key: string, value: string) => {
    window.sessionStorage.setItem(key, value);
    return true;
};

export const getSessionStorage = (key: string) => window.sessionStorage.getItem(key);

export const getPersistentView = (url: string, replaceSelectors = true) => {
    const data: PersistentViewItem[] = JSON.parse(getSessionStorage(url) || '[]');
    if (!replaceSelectors) return data;
    data.forEach((item) => {
        const wrapper = document.querySelector(item.selector);
        if (!wrapper) return;
        wrapper.outerHTML = sanitize(item.element);
    });
};

export const setPersistentView = (url: string, ...selectors: string[]) => {
    const data: PersistentViewItem[] = [];
    selectors.forEach((selector) => {
        data.push({
            selector,
            element: document.querySelector(selector)?.outerHTML || '',
        });
    });
    return setSessionStorage(url, JSON.stringify(data));
};

export const removeAllPersistentViews = (url: string) => {
    Object.keys(window.sessionStorage).forEach((item) => {
        if (!(item === url || item.includes('take=async'))) return;
        removeSessionStorage(item);
    });
};
